import { BaseDto } from '@up/data';

export class FireBatchPaymentDto extends BaseDto {
  transferId: number;
  referenceId: number;
  type?: string;
  typeId?: number;
  isRefund?: boolean;
  description?: string;
  grossAmount?: number;
  cardFeeAmount?: number;
  cardFeePercentage?: number;
  processingFeeAmount?: number;
  serviceFeeAmount?: number;
  serviceChargeAmount?: number;
  deliveryFeeAmount?: number;
  refundProcessingFeeAmount?: number;
  date?: Date;
}
